"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    user: 'Användare' || 'user',
    register: '' || 'register',
    writeUser: 'Uppdatera användare' || 'writeUser',
    editUser: 'Uppdatera användare' || 'editUser',
    changePassword: 'Byt lösenord' || 'changePassword',
    verify: '' || 'verify',
    disable: 'Inaktivera användare' || 'disable',
    enable: 'Aktivera användare' || 'enable',
    forgotPassword: '' || 'forgotPassword',
    resetPassword: '' || 'resetPassword',
    resolveToken: '' || 'resolveToken',
    changeActiveOrganization: 'Byt organization' || 'changeActiveOrganization',
    endImpersonation: 'Byt organization' || 'endImpersonation',
    login: '' || 'login',
    socialLogin: '' || 'socialLogin',
    me: '' || 'me',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    firstName: 'Förnamn' || 'firstName',
    lastName: 'Efternamn' || 'lastName',
    email: 'ePost' || 'email',
    password: 'Lösenord' || 'password',
    avatar: 'Bild' || 'avatar',
    organization: 'Organisation' || 'organization',
    roles: 'Roll' || 'roles',
    roles: {
        super: 'Allsmäktig' || 'super',
        qvantiSupplierRoleSupplierAdmin: 'Leverantörsadmin' || 'qvantiSupplierRoleSupplierAdmin',
        supplier: 'Leverantör' || 'supplier',
        qvantiSupplierRoleArticleChanges: 'Administrera artikeldata' || 'qvantiSupplierRoleArticleChanges',
        qvantiSupplierRoleOrderAcceptance: 'Ordermottagning' || 'qvantiSupplierRoleOrderAcceptance',
        qvantiSupplierRolePriceChanges: 'Administera prislistor' || 'qvantiSupplierRolePriceChanges',
        qvantiSupplierRoleCustomerChanges: 'Admninistrera kunddata' || 'qvantiSupplierRoleCustomerChanges',
    },
    active: 'Aktiverad' || 'active',
    verified: 'Verifierad' || 'verified',
    isRestrictedByOfc: 'Begränsa till leveranslager' || 'isRestrictedByOfc',
    token: '' || 'token',
    resetTokenExpires: '' || 'resetTokenExpires',
    verificationToken: '' || 'verificationToken',
    lastLoginAt: 'Senast inloggad' || 'lastLoginAt',
    shouldReceiveAlertEmails: 'Skicka e-post till användare för notiser' || 'shouldReceiveAlertEmails',
    ofcAccesses: {
        id: 'Identitet' || 'id',
        accessToOfc: 'Leveranslager' || 'accessToOfc',
    },
};
